const images = {
  // logo: require('~/assets/images/logo.svg').default,
  // tenten: require('~/assets/svg').tenten,
  bgr: require('~/assets/huk.png'),
  logo: require('~/assets/logo.jpg'),
  footImg: require('~/assets/foot.png'),
  logoGioVang: require('~/assets/logoGioVang.png'),
  // orderOther1: require('~/assets/orderweb/1.svg').default,
};

export default images;
